<template>
  <v-card
    class="card text-body-1 pl-0 pt-4"
    color="neutral2"
    :to="{ name: 'Result', params: { id: raffle._id } }"
  >
    <div class="d-flex">
      <div class="d-flex align-center">
        <v-sheet
          class="mr-2 rounded-l-0 rounded-r-lg"
          color="secondary"
          width="0.375rem"
          height="5rem"
        ></v-sheet>

        <div class="d-flex flex-column">
          <div class="text-body-2 font-weight-bold neutral8--text">
            Concurso #{{ raffle.code }}
          </div>

          <div class="raffle-title text-uppercase font-weight-bold">
            {{ raffle.name }}
          </div>

          <div>
            <span class="text-h5 font-weight-black primary--text">
              R$ {{ currencyMask(raffle.awards.cash) }}
            </span>
          </div>
        </div>
      </div>

      <v-spacer />

      <div v-if="raffle.status === 'finished'">
        <v-chip
          class="pulse font-weight-bold"
          :color="raffle.winner ? 'yellow accent-3' : 'blue'"
          :class="{ 'neutral--text': raffle.winner }"
          label
        >
          {{ raffle.winner ? "PREMIADA" : " ACUMULOU!" }}

          <v-icon v-if="raffle.winner" color="black" right small>
            fas fa-trophy
          </v-icon>
        </v-chip>
      </div>
    </div>

    <div
      v-if="
        (!hideFooter && raffle.status === 'finished') ||
        raffle.status === 'cancelled'
      "
      class="pl-4 mt-2"
    >
      <div v-if="raffle.status === 'finished'" class="text1--text mb-n1">
        Número premiado:
        <span class="font-weight-black accent--text text-h6">
          {{ raffle.result }}
        </span>
      </div>

      <div
        v-else-if="raffle.status === 'cancelled'"
        class="error--text font-weight-bold"
      >
        Cancelado
      </div>

      <div class="neutral8--text">
        Sorteio
        {{ raffle.status === "cancelled" ? "cancelado" : "realizado" }}
        no dia
        <span class="font-weight-bold text1--text">
          {{
            formatTimezoneDate(
              raffle.finishedAt,
              "D [de] MMM [de] YYYY [às] HH[h]mm"
            )
          }}
        </span>
      </div>
    </div>
  </v-card>
</template>

<script>
import { currencyMask, formatTimezoneDate } from "@/helpers";

export default {
  name: "RaffleCard",

  props: {
    raffle: {
      type: Object,
      required: true,
    },

    hideFooter: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    currencyMask,

    formatTimezoneDate,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
